import EducationStep from './EducationStep';
import AwardsStep from './AwardsStep';

// Step 4 (consolidated): Education + Professional Certifications & Licenses + Civilian &
// Professional Recognition on one page. Both child steps use the parent's
// registerPendingData (which merges disjoint slices), so their edits save together on
// navigation. No new data model — each child owns its existing fields.
export default function EducationCredentialsStep(props) {
  return (
    <div className="space-y-10" data-testid="education-credentials-step">
      <div>
        <h3 className="text-lg font-semibold text-slate-900 mb-3">Education</h3>
        <EducationStep {...props} />
      </div>
      <div className="pt-2 border-t border-slate-200">
        <AwardsStep {...props} />
      </div>
    </div>
  );
}
